// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__3cy0A","content":"Layout_content__2AqfG"};